var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.0433 10.7441C16.8118 12.9191 15.5795 14.9572 13.5404 16.1345C10.1524 18.0905 5.82035 16.9297 3.86434 13.5418L3.656 13.1809M2.95429 9.25578C3.1858 7.08086 4.41812 5.04276 6.45728 3.86545C9.84518 1.90944 14.1773 3.07023 16.1333 6.45813L16.3416 6.81898M2.91016 15.055L3.5202 12.7783L5.79691 13.3883M14.2012 6.61161L16.4779 7.22165L17.0879 4.94495",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw05);
export default __webpack_public_path__ + "static/media/refresh-cw-05.1ac80deac734730c1781f0c7ab2fe9f8.svg";
export { ForwardRef as ReactComponent };